<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (properties.length > 0) {
  <p-table #pt [value]="hotelListings" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="hotelListingId" selectionMode="single"
    [(selection)]="hotelListing" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
    [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
    <ng-template pTemplate="caption">
      <div class="d-block text-end justify-content-between align-items-center">
        <h1 style="float: left;margin: 6px;">Hotel Room Children</h1>
        <span>
          <!-- clear filters -->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="reloadPage()">Clear Filters</button>
          }
          <!-- rebind RU sub-units -->
          @if (shortTermRentalId) {
            <button pButton pRipple class="p-button-outlined p-button-secondary"
              style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              title="Trigger eager-binding of RU UnitId / ResApaID values for this hotel-room's children. Idempotent — already-mapped slots are preserved."
              (click)="onRebindRuSubUnits()">Rebind RU Sub-Units</button>
          }
          <!-- add new -->
          @if (!outlineNewButton && shortTermRentalId) {
            <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">Add Child Unit +</button>
          }
          @if (outlineNewButton && shortTermRentalId) {
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">Add Child Unit +</button>
          }
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      @if (showFilter) {
        <tr>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'hotelListingId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'hotelShortTermRentalId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
          <th>
            <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="sitePriorities" appendTo="body"
              (onChange)="pt.filter($event.value, 'listingPriority', 'in')" styleClass="p-column-filter" placeholder="Filter"
              [showClear]="true" optionLabel="name" optionValue="value">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          </th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ruSubUnitId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-hotelListing>
      <tr [pSelectableRow]="hotelListing">
        <td>{{hotelListing.hotelListingId}}</td>
        <td>{{getPropertyCode(hotelListing.hotelShortTermRentalId)}}</td>
        <td><a href="/property-edit/{{hotelListing.shortTermRentalId}}" target="_blank">{{getPropertyCode(hotelListing.shortTermRentalId)}}</a></td>
        <td>{{hotelListing.listingPriority}}</td>
        <td>{{hotelListing.ruSubUnitId ?? '—'}}</td>
        <td>
          <span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
                 style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(hotelListing)"></i>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
